import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ThemesService from "../api/themes";
import { getUrlVars } from "../utils/systemInfo";
import TemplateAddEdit from "../common/Layout/templatePages/templateAddEdit";
import { setThemeApi } from "../store/themeApiSlice";

const initialState = {
  theme_id: "",
  name: "",
  description: "",
  status: "active",
};

const breadcrumbs = [
  { id: 0, name: "Home", href: "./" },
  { id: 1, name: "Themes", href: "themesApi" },
  { id: 2, name: "Add/Edit Theme", href: "addEditThemeApi" },
];
function AddEditThemeApi() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const themeApi = useSelector(({ themeApi }) => themeApi);
  const organziation = useSelector(({ organziation }) => organziation);
  const themeApiId = String(getUrlVars()["id"]);

  useEffect(() => {
    if (!getUrlVars()["id"]) {
      dispatch(setThemeApi(initialState));
    }
    if (themeApi.theme_id === "" && getUrlVars()["id"]) {
      const apiKey =
        organziation?.api_key_list?.[0]?.key ?? localStorage.getItem("apiKey");
      ThemesService.getThemeProfile({
        theme_profile_id: themeApiId,
        apiKey,
      })
        .then((jsonCurrent) => {
          if (jsonCurrent?.theme_profile?.length) {
            const themeObject = jsonCurrent?.theme_profile[0];
            dispatch(
              setThemeApi({
                theme_id: themeObject.theme_id,
                name: themeObject.name,
                description: themeObject.description,
                status: themeObject.status,
              })
            );
          }
        })
        .catch((errorr) => {
          if (process.env.NODE_ENV === "development")
            console.log("getUserTypePermissionserrorr", errorr);
        });
    }

    // return () => {
    //   dispatch(setTag(initialState));
    // };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [themeApi]);

  function handleSave({
    theme_id,
    name,
    description,
    status,
    api_key_current,
  }) {
    ThemesService.SetThemeProfile({
      theme_id,
      name,
      description,
      status,
      api_key_current,
    }).then((json) => {
      if (json.success === true && json.count > 0) {
        navigate("/themesApi");
      }
    });
  }
  return (
    <TemplateAddEdit
      breadcrumbs={breadcrumbs}
      title="Add/EditThemeProfile"
      gridCol={2}
      item={themeApi}
      dataToShow={[
        { key: "name", /*label: "Name",*/ type: "text", isRequired: true },
        { key: "description", type: "text" },
        { key: "status", type: "text" },
      ]}
      onSaveClick={(item) =>
        handleSave({
          ...item,
          api_key_current: organziation?.api_key_list?.[0]?.key,
        })
      }
    />
  );
}

export default AddEditThemeApi;
